import { CRow, CCol, CCard, CCardBody, CCardHeader, CAlert } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilPeople, cilUser, cilShieldAlt, cilStar, cilCheckAlt } from '@coreui/icons'
import React, { useState } from 'react'
import PlayerProfileListing from './PlayerProfileListing'
import TeamPlayerImage from './TeamPlayerImage'
import PlayerBulkImageUpload from './PlayerBulkImageUpload'
import PlayerPositionBulkUpload from './PlayerPositionBulkUpload'
import TeamSponsorLogo from './TeamSponsorLogo'

const MODES = [
  {
    key: 'players',
    title: 'By Players',
    description: 'Select individual players',
    icon: cilPeople,
    iconBg: '#EEF2FF',
    iconColor: '#6366F1',
  },
  {
    key: 'position',
    title: 'By Position',
    description: 'Apply to everyone in a position',
    icon: cilUser,
    iconBg: '#ECFDF5',
    iconColor: '#10B981',
  },
  {
    key: 'team',
    title: 'By Team',
    description: 'Apply to everyone associated with a team',
    icon: cilShieldAlt,
    iconBg: '#EFF6FF',
    iconColor: '#3B82F6',
  },
  {
    key: 'sponsor',
    title: 'Team Sponsor',
    description: "Use each team's sponsor logo",
    icon: cilStar,
    iconBg: '#FEF3E2',
    iconColor: '#F59E0B',
  },
]

const PlayerProfile = () => {
  const [users, setUsers] = useState([])
  const [refreshKey, setRefreshKey] = useState(0)
  const [mode, setMode] = useState('players')

  return (
    <>
      <CRow className="mb-3">
        <CCol>
          <h4 className="fw-bold mb-1">Bulk Profile Images</h4>
          <div className="text-medium-emphasis mb-3">
            Apply profile images to multiple player records using selection rules.
          </div>
          <CRow className="g-3">
            {MODES.map((item) => (
              <CCol sm={6} lg={3} key={item.key}>
                <CCard
                  className={
                    'h-100' + (mode === item.key ? ' border-primary' : ' border-secondary-subtle')
                  }
                  style={{ cursor: 'pointer' }}
                  onClick={() => setMode(item.key)}
                >
                  <CCardBody className="d-flex align-items-start justify-content-between p-3">
                    <div className="d-flex align-items-start">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 me-3"
                        style={{ width: 44, height: 44, backgroundColor: item.iconBg }}
                      >
                        <CIcon icon={item.icon} style={{ color: item.iconColor }} size="lg" />
                      </div>
                      <div>
                        <div className="fw-semibold">{item.title}</div>
                        <div className="text-medium-emphasis small">{item.description}</div>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                      style={{
                        width: 22,
                        height: 22,
                        marginLeft: 8,
                        border: mode === item.key ? 'none' : '1.5px solid #ced4da',
                        backgroundColor: mode === item.key ? '#4F46E5' : 'transparent',
                      }}
                    >
                      {mode === item.key && (
                        <CIcon icon={cilCheckAlt} style={{ color: '#fff' }} size="sm" />
                      )}
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
            ))}
          </CRow>
          <CAlert color="info" className="mt-3 mb-0">
            Players, Position and Team use one uploaded image. Team Sponsor uses each team&apos;s
            assigned sponsor logo.
          </CAlert>
        </CCol>
      </CRow>

      <CRow className="mb-4">
        <CCol>
          <CCard>
            <CCardBody>
              {mode === 'players' && <PlayerBulkImageUpload setRefreshKey={setRefreshKey} />}
              {mode === 'position' && <PlayerPositionBulkUpload setRefreshKey={setRefreshKey} />}
              {mode === 'team' && <TeamPlayerImage setRefreshKey={setRefreshKey} />}
              {mode === 'sponsor' && <TeamSponsorLogo setRefreshKey={setRefreshKey} />}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol>
          <CCard>
            <CCardHeader>
              <strong>Manage Players Profile</strong>
            </CCardHeader>
            <CCardBody>
              <PlayerProfileListing users={users} setUsers={setUsers} refreshKey={refreshKey} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default PlayerProfile
